import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Alert, Button, Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import {daliHelvarActions} from "../../../../actions/dali-helvar.actions";
import DaliHelvarGroupTable from "./_components/DaliHelvarGroupTable";
import DaliHelvarGroupForm from "./_forms/DaliHelvarGroupForm";
import {modalActions} from "../../../../actions/modal.actions";
import DaliDeviceInfo from "../_components/DaliDeviceInfo";

class DaliHelvarGroupPage extends Component {

    id = null;
    areaId = null;

    componentDidMount() {
        const { dispatch } = this.props;
        this.id = this.props.match.params.id;
        this.areaId = this.props.match.params.areaId;

        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(this.id));
        dispatch(daliHelvarActions.getHelvarAreaById(this.areaId));
        dispatch(daliHelvarActions.getHelvarGroups(this.id));
    }

    openModalCreateHelvarGroup = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_dali-group'),
            component: <DaliHelvarGroupForm deviceId={this.id} daliHelvarAreaId={this.areaId} submitForm={this.handleSubmitCreateGroup}/>
        };

        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitCreateGroup = (model) => {
        const { dispatch } = this.props;
        dispatch(daliHelvarActions.createHelvarGroup(model));
    };

    render() {
        const { t, simpleDeviceInfo, loader, loaderMsg, helvarGroupList, helvarAreaItem } = this.props;
        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: `${t('area')} - ${helvarAreaItem?.label}`, path: `/panel/network-device/dali/helvar/${this.id}/area` },
            { value: 'dali-groups', path: '#' },
        ];

        const extendInfo = [
            { key: 'area', value: helvarAreaItem?.label }
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DaliDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={'dali-groups'} infoElements={extendInfo}/>
                { !loader ? (
                    <div className="card">
                        <div className="card-header">
                            <div className="button-group float-right">
                                <Button variant={"success"} onClick={this.openModalCreateHelvarGroup}>
                                    <i className="fas fa-plus"/> {t('create')}
                                </Button>
                                &nbsp;
                                <Link to={`/panel/network-device/dali/helvar/${this.id}/area`} className="btn btn-secondary">
                                    <i className="fas fa-undo"> </i> {t('back-to-list-area')}
                                </Link> &nbsp;
                            </div>
                        </div>
                        <div className="card-body">
                            <DaliHelvarGroupTable list={helvarGroupList} device={simpleDeviceInfo} area={helvarAreaItem}/>
                        </div>
                    </div>
                ) : (
                    <Alert variant={"warning"}>
                        <h4>{t(loaderMsg)}</h4>
                        <Spinner animation={"border"} />
                    </Alert>
                )}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo, loader, loaderMsg } = state.networkDeviceReducer;
    const { helvarAreaItem, helvarGroupList } = state.daliHelvarReducer;
    return {
        simpleDeviceInfo,
        helvarAreaItem,
        helvarGroupList,
        loader,
        loaderMsg
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliHelvarGroupPage))
